import React from 'react';

import { ConsultasExternas } from '../ConsultasExternas';
import { ConsultasInternas } from '../ConsultasInternas';

export function TabConsultas({
  data,
  tipoSolicitacao,
  observacaoInterna,
  carregarSolicitacaoAtual,
}) {
  return <>
    {tipoSolicitacao === 2 && (
      <ConsultasExternas data={data?.consultasAtendimento} />
    )}
    {tipoSolicitacao === 1 && (
      <ConsultasInternas
        divergencias={data?.consultasAtendimento}
        historico={data?.observacoesAtendimentosAnteriores}
        isReanalise={data?.isReanalise}
        aguardandoConsultaExterna={data?.aguardandoConsultaExterna}
        observacaoInterna={observacaoInterna}
        carregarSolicitacaoAtual={carregarSolicitacaoAtual}
      />
    )}
         </>;
}
